import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GDAccountNumberCell from 'Components/GDTable/GDAccountNumberCell/GDAccountNumberCell.jsx';
import { customFormatclass, customClassSummary } from '../GDCustomFormat/GDCustomFormat';
import MoreIcon from 'Assets/img/angle-up-light.svg';
import LessIcon from 'Assets/img/angle-down-light.svg';
import './GDTableSummaryHorizontalPanel.scss';
import moment from 'moment';
import InformationBubble from 'Components/information-bubble/InformationBubble';
//import 'antd/dist/antd.css';
import UserLockIcon from 'Components/icons/UserLockIcon.jsx';
import ExternalLink from '../../icons/ExternalLink/ExternalLink';
import { VITE_TRANSACTION_UNMATCHED_QUEUE } from 'Constants/appEnvConstants';

let summaryData = [];
class GDTableSummaryHorizontalPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExpandedpanel: false,
      isLoading: false,
      index: -1
    };
    summaryData=this.props.summaryData;
    this.attachBindings();
  }
  attachBindings() {

    this.getItems = this.getItems.bind(this);
    this.assignmentSummary = this.assignmentSummary.bind(this);
    this.assignCurrentPage = this.assignCurrentPage.bind(this);
  }

  assignCurrentPage(index,contentIndex) {
    


    let isAssignPages = true;
    let data = {};
    let currentSelectedIndexArray = [];
    currentSelectedIndexArray.push(this.props.pageList[this.props.currentSelectedImageIndex]);


    if (summaryData.length > 0) {
      let count = 0;
      data = summaryData.filter((summaryItem) => {
        if (index == summaryItem.index) {
          summaryItem.clear == true ?
            (summaryItem.pages = currentSelectedIndexArray,
              summaryItem.clear = false, summaryItem.isAttachSuccess=null )
            :
            (summaryItem.pages = summaryItem.pages.some(pages => pages.pageId == currentSelectedIndexArray[0].pageId) ? summaryItem.pages : summaryItem.pages.concat(currentSelectedIndexArray),
              summaryItem.clear = false, summaryItem.isAttachSuccess=null)

          count++;
        }


      })
      if (count == 0) {
        data = {
          caseNbr: this.props.summaryContent[contentIndex].caseDetail_caseNumber,
          caseStageId:this.props.summaryContent[contentIndex].caseStageDetail_caseStageId,
          pages: currentSelectedIndexArray,
          index: index,
          clear: false,
        };
      }
    } else {

      data = {
        caseNbr:this.props.summaryContent[contentIndex].caseDetail_caseNumber,
        caseStageId:this.props.summaryContent[contentIndex].caseStageDetail_caseStageId,
        pages: currentSelectedIndexArray,
        index: index,
        clear: false,
      };

    }

    summaryData = summaryData.concat(data);
    this.props.setSummaryData(summaryData, isAssignPages);
 
  }


  assignmentSummary(index,contentIndex) {
    let isAssignPages = true;
    let data = {};
    let count = 0;
    var ids;

    if (summaryData.length > 0) {
    
      data = summaryData.filter((filter) => {
        if (index == filter.index) {
          
           
          filter.clear==true? (
            filter.pages=this.props.selectedPages.length == 0 ? this.props.pageList:this.props.selectedPages,
            filter.clear = false,
             filter.isAttachSuccess=null
          ):
          ( 
            ids = new Set(filter.pages.map(page => page.pageId)),
             filter.pages =this.props.selectedPages.length == 0 ? this.props.pageList:
              ([...filter.pages, ...this.props.selectedPages.filter(page => !ids.has(page.pageId))]),
             filter.clear=false,
            filter.isAttachSuccess=null)
            count++;
          
          
        }
      


      })
      if (count == 0) {
        data = {
          caseNbr: this.props.summaryContent[contentIndex].caseDetail_caseNumber,
          caseStageId:this.props.summaryContent[contentIndex].caseStageDetail_caseStageId,
          pages: this.props.selectedPages.length == 0 ? this.props.pageList : this.props.selectedPages,
          index: index,
          clear: false,
        };
      }

    }
    else{
      data = {
        caseNbr: this.props.summaryContent[contentIndex].caseDetail_caseNumber,
        caseStageId:this.props.summaryContent[contentIndex].caseStageDetail_caseStageId,
        pages: this.props.selectedPages.length == 0 ? this.props.pageList : this.props.selectedPages,
        index: index,
        clear: false,
      };}

    summaryData = summaryData.concat(data);
    this.props.setSummaryData(summaryData, isAssignPages);
  }

  togglehorizontal = (index) => {
    this.setState({ isExpandedpanel: !this.state.isExpandedpanel, index });
  }
  getItems(index) {
    return this.state.isExpandedpanel && index == this.state.index ? this.props.summaryFields : this.props.summaryFields.filter((listItem, index) => {
      return listItem.defaultIsVisible == true;
    });
  }
  addButton(buttonName, summaryContent, contentIndex, isReadOnly) {
    if (!this.props.isAttachStarted)
      return (<button type="button" disabled={isReadOnly} onClick={() => this.props.actionMethod(summaryContent, contentIndex)} className="selectbtn">{buttonName}</button>);
    if (this.props.isAttachStarted)
      return (<button type="button" disabled onClick={() => this.props.actionMethod(summaryContent, contentIndex)} className="selectbtn">{buttonName}</button>);
  }
  renderTitle() {
    if (this.props.summaryContent !== undefined && this.props.summaryContent.length > 0) {
      return (
        <div className="title">
          <h2>{this.props.title}</h2>
        </div>);
    }
  }
  render() {

    const mainContentClass = this.props.type == VITE_TRANSACTION_UNMATCHED_QUEUE ? 'gd-table__summary-horizontal-panel' : 'image-search-panel';
    return (
      this.props.isMerchantPortal || this.props.type == VITE_TRANSACTION_UNMATCHED_QUEUE ?
        <div>
          {this.renderTitle()}
          {this.props.summaryContent !== undefined && this.props.summaryContent.length > 0 && this.props.summaryContent.map((summaryContent, contentIndex) => {
            return (<div className={mainContentClass} key={contentIndex}>

              <ul key={summaryContent.id} className="panel-container">
                {this.getItems(contentIndex).map((column, index) => {
                  let valueClass;
                  if ((column.displayType === 'CURRENCY' || column.displayType === 'NEGATIVE_NUMBER') && Number.parseFloat(summaryContent[column.columnKey]) < 0) {
                    valueClass = customFormatclass(customClassSummary, column.displayType);
                  } else if (Number.parseFloat(summaryContent[column.columnKey]) < 0) {
                    valueClass = customFormatclass(customClassSummary, column.displayType);
                  }

                  const handlePrecision = (amount, precision) => {
                    if (amount !== undefined && amount !== null) {
                      const arr = `${amount}`.split('.');
                      return arr.length > 1
                        ? `${arr[0] <= 0 ? arr[0] * -1 : arr[0]}.${arr[1].length === 1 ? `${arr[1]}0` : arr[1].substr(0, precision)}`
                        : `${amount <= 0 ? amount * -1 : amount}.00`;
                    }
                    return '--';
                  };

                  const handleEmptyValues = (dataVal) => {
                    if (dataVal === null || dataVal === undefined) { return '--'; } else { return dataVal; }
                  };
                  let value;
                  let currencyCode;
                  if (column.displayType === 'CURRENCY') {
                    const currencyValue = handlePrecision(summaryContent[column.columnKey], 2);
                    value = currencyValue;
                    currencyCode = summaryContent.currencyCode;
                  } else if (column.displayType === 'STRING') {
                    value = handleEmptyValues(summaryContent[column.columnKey]);
                  } else if (column.displayType === 'NEGATIVE_NUMBER') {
                    value = handlePrecision(summaryContent[column.columnKey], 2);
                  } else if (column.displayType === 'ACCOUNTNUMBER') {
                    value = (<GDAccountNumberCell
                      isReadOnly={this.props.isReadOnly}
                      accountNumber={(summaryContent[column.columnKey]) === undefined || (summaryContent[column.columnKey]) === null ? '--' : (summaryContent[column.columnKey])}
                      token={summaryContent[column.secondaryColumnKey === undefined ? 'globalToken' : column.secondaryColumnKey]}

                    />);
                  } else if (column.displayType === 'INDICATOR') {
                    value = summaryContent[column.columnKey] === '1' ? 'Yes' : 'No';
                  } else if (column.displayType === 'DATE') {
                    const date = moment(summaryContent[column.columnKey]);
                    value = date.format(this.props.dateFormat);
                  } else {
                    value = summaryContent[column.columnKey];
                  }
                  if (column.displayType === 'BUTTON') {
                    if (!(this.props.type == VITE_TRANSACTION_UNMATCHED_QUEUE) && this.props.user !== undefined && this.props.user.parsedPermissions.queue.archiveImages === true) {
                      return (
                        <li className="custom-wrapper" key={contentIndex} >{this.addButton(column.name, summaryContent, contentIndex, this.props.isReadOnly)}
                        </li>
                      );
                    }
                    else if (this.props.type == VITE_TRANSACTION_UNMATCHED_QUEUE && this.props.user !== undefined && this.props.user.parsedPermissions.queue.addManualTransaction === true) {
                      return (
                        <li className="custom-wrapper" key={contentIndex} >{this.addButton(column.name, summaryContent, contentIndex, this.props.isReadOnly)}
                        </li>
                      );
                    }
                    else {
                      return (<li className="custom-wrapper" key={contentIndex} ></li>);
                    }
                  }

                  return (<li
                    className={column.IsLockedByUserVisible ? column.isCustomRow ? "locked-user-visible custom-wrapper " : "wrapper" : column.isCustomRow ? "custom-wrapper" : "wrapper"}
                    key={column.columnKey}
                  >{summaryContent.isCaseLocked && column.IsLockedByUserVisible &&
                    <span className="locked-text"><UserLockIcon key={column.index} className="lockIcon" color="#d31c3c" height="10px" width="15px" />This case is locked by {summaryContent.userName}</span>
                    }
                    {!column.IsLockedByUserVisible && <div >
                      <span className="item-label">
                        {column.name}
                      </span>
                      <span>
                        {column.displayType !== 'CURRENCY' && <span className={column.isCustomRow ? valueClass || 'custom-item-amount' : valueClass || 'item-amount'}>{value}
                          {column.displayType == 'RC' && <InformationBubble
                            id={column.descriptionKey}
                            info
                            tooltipContent={`${summaryContent[column.descriptionKey]}`}
                          />

                          }
                        </span>}
                        {column.displayType === 'CURRENCY' &&
                          <div className="currency-div">
                            <span className={valueClass || 'gd-table__summary-horizontal-panel-list-item-amount currency-span'}>{value}</span>&nbsp;&nbsp;
                          <span className="currency-code gd-currency-code-cell__currency-code ">{currencyCode}</span>
                          </div>
                        }
                      </span>
                    </div>
                    }
                  </li>);
                })}
              </ul>

              <div onClick={() => this.togglehorizontal(contentIndex)} >
                {this.state.isExpandedpanel && this.state.index == contentIndex ? <img src={MoreIcon} className="panel-less" /> :
                  <img src={LessIcon} className="panel-more" />}
              </div>
            </div>);
          })}
        </div> :
        //Merchant and Scheme img code from here
        <div>
          {console.log("Running second div")}
          {this.renderTitle()}
          {this.props.summaryContent !== undefined && this.props.summaryContent.length > 0 && this.props.summaryContent.map((summaryContent, contentIndex) => {
            return (<div>
              <div className={mainContentClass}>
                <ul key={summaryContent.id} className="panel-container" style={{ marginBottom: "1.3%" }}>
                  {this.getItems(contentIndex).map((column, index) => {
                    let valueClass;
                    if ((column.displayType === 'CURRENCY' || column.displayType === 'NEGATIVE_NUMBER') && Number.parseFloat(summaryContent[column.columnKey]) < 0) {
                      valueClass = customFormatclass(customClassSummary, column.displayType);
                    } else if (Number.parseFloat(summaryContent[column.columnKey]) < 0) {
                      valueClass = customFormatclass(customClassSummary, column.displayType);
                    }

                    const handlePrecision = (amount, precision) => {
                      if (amount !== undefined && amount !== null) {
                        const arr = `${amount}`.split('.');
                        return arr.length > 1
                          ? `${arr[0] <= 0 ? arr[0] * -1 : arr[0]}.${arr[1].length === 1 ? `${arr[1]}0` : arr[1].substr(0, precision)}`
                          : `${amount <= 0 ? amount * -1 : amount}.00`;
                      }
                      return '--';
                    };

                    const handleEmptyValues = (dataVal) => {
                      if (dataVal === null || dataVal === undefined) { return '--'; } else { return dataVal; }
                    };
                    let value;
                    let currencyCode;
                    let currencyValue;
                    let daysLeft;
                    if (column.displayType === 'STRING') {
                      value = handleEmptyValues(summaryContent[column.columnKey]);
                    } else if (column.displayType === 'NEGATIVE_NUMBER') {
                      value = handlePrecision(summaryContent[column.columnKey], 2);
                    } else if (column.displayType === 'ACCOUNTNUMBER') {
                      value = (<GDAccountNumberCell
                        isReadOnly={this.props.isReadOnly}
                        cardBrandCode={summaryContent[column.cardLogoKey]}
                        accountNumber={(summaryContent[column.columnKey]) === undefined || (summaryContent[column.columnKey]) === null ? '--' : (summaryContent[column.columnKey])}
                        token={summaryContent[column.secondaryColumnKey === undefined ? 'globalToken' : column.secondaryColumnKey]}
                        showCardLogo={true}

                      />);
                    } else if (column.displayType === 'INDICATOR') {
                      value = summaryContent[column.columnKey] === '1' ? 'Yes' : 'No';
                    } else if (column.displayType === 'DATE') {
                      const date = moment(summaryContent[column.columnKey]);
                      value = date.format(this.props.dateFormat);
                      //SEcondary column for currency
                      currencyValue = handlePrecision(summaryContent[column.secondaryColumnKey], 2);
                      currencyCode = summaryContent.currencyCode;
                    }
                    else if (column.displayType === "DISP") {
                      value = summaryContent[column.columnKey];
                    } else if (column.displayType === "STATUS") {
                      value = summaryContent[column.columnKey] == '1' ? '- Open' : '- Closed';
                      daysLeft = summaryContent[column.secondaryColumnKey];
                    } else {
                      value = summaryContent[column.columnKey];
                    }
                    if (column.displayType === 'BUTTON') {
                      if (!(this.props.type == VITE_TRANSACTION_UNMATCHED_QUEUE) && this.props.user !== undefined && this.props.user.parsedPermissions.queue.archiveImages === true) {
                        return (
                          <li className="custom-wrapper" key={summaryContent.id} >{this.addButton(column.name, summaryContent, contentIndex, this.props.isReadOnly)}
                          </li>
                        );
                      }
                      else if (this.props.type == VITE_TRANSACTION_UNMATCHED_QUEUE && this.props.user !== undefined && this.props.user.parsedPermissions.queue.addManualTransaction === true) {
                        return (
                          <li className="custom-wrapper" key={summaryContent.id} >{this.addButton(column.name, summaryContent, contentIndex, this.props.isReadOnly)}
                          </li>
                        );
                      }
                      else {
                        return (<li className="custom-wrapper" key={summaryContent.id} ></li>);
                      }
                    }

                    return (column.isBorderClass ? <span className="border-class"></span> :

                      <li key={summaryContent.id}
                        className={column.IsLockedByUserVisible ? column.isCustomRow ? "locked-user-visible custom-wrapper" : "wrapper" :
                          column.isCustomRow ? column.displayType === "DISP" ? "wrapper-disp" : "custom-wrapper2"
                            : "wrapper"}
                        key={column.columnKey}
                      >{summaryContent.isCaseLocked && column.IsLockedByUserVisible &&
                        <span className="locked-text"><UserLockIcon className="lockIcon" color="#d31c3c" height="10px" width="15px" />This case is locked by {summaryContent.userName}</span>
                        }
                        {!column.IsLockedByUserVisible && <div >
                          <span className="item-label_img">
                            {column.name}
                          </span>

                          <span>


                            {column.displayType !== 'DATE' && column.displayType !== "DISP" &&
                              column.displayType !== "STATUS" && <span className={column.isCustomRow ? valueClass || 'custom-item-amount_2' : valueClass || 'item-amount'}>
                                {column.name == 'Case Number' ?
                                  <span className="case-Colour" onClick={() => this.props.goToCaseLandingPageByCaseNumber(summaryContent, contentIndex)} >{value}&nbsp;</span> : value}
                                {column.name == 'Case Number' &&
                                  <  span onClick={() => this.props.goToCaseLandingPageByCaseNumber(summaryContent, contentIndex)}> {<ExternalLink />} </span>}
                                {column.displayType == 'RC' && <InformationBubble
                                  id={column.descriptionKey}
                                  info
                                  tooltipContent={`${summaryContent[column.descriptionKey]}`}
                                />}
                              </span>
                            }


                            <div>
                              {
                                column.displayType === 'DISP' && <span className={valueClass || 'field-value'}>{value}</span>
                              }
                            </div>



                            {column.displayType === 'DATE' &&
                              <div className="currency-div">
                                <span className={valueClass || 'custom-item-amount_3'}>{currencyValue}</span>&nbsp;
                       <span className="currency-code gd-currency-code-cell__currency-code ">{currencyCode}</span>&nbsp;&nbsp;
                       <span className={valueClass || 'custom-item-amount_3'}>{value}</span>
                              </div>
                            }

                            {column.displayType === 'STATUS' &&
                              <div className="currency-div">
                                <span className={valueClass || 'custom-item-amount_3'}>{daysLeft}</span>&nbsp;
                                <span className={valueClass || 'custom-item-amount_3'}>{value}</span>
                              </div>}

                          </span>
                        </div>
                        }
                      </li>);
                  })}
                  <div onClick={() => this.togglehorizontal(contentIndex)} >
                    {this.state.isExpandedpanel && this.state.index == contentIndex ?
                      <img src={MoreIcon} className="panel-less1" /> :
                      <img src={LessIcon} className="panel-more1" />}
                  </div>
                </ul>
                <ul key={summaryContent.id} className="panel-container end-panel" >
                  <li key={summaryContent.id} className="locked-user-visible custom-wrapper locked-wrapper"></li>
                  <li key={summaryContent.id} className="custom-wrapper action-wrapper">
                    <div>
                      {<button type="button" className="hollow-button-view" onClick={() => this.assignmentSummary(this.props.summaryContent[contentIndex].caseDetail_caseNumber,contentIndex)}><label className="hollow-label_2">{this.props.summaryPanel[0].name}</label></button>}
                    </div>
                    <div>
                      <button type="button" className="hollow-button-view" onClick={() => this.assignCurrentPage(this.props.summaryContent[contentIndex].caseDetail_caseNumber,contentIndex)} style={{ marginRight: '2px' }}>
                        <label className="hollow-label_1">Assign Current Page</label>
                      </button>
                    </div>
                  </li>
                </ul>

              </div>

            </div>
            )
          })}
        </div>

    );
  }

}
GDTableSummaryHorizontalPanel.propTypes = {

  extraClass: PropTypes.string,
  summaryFields: PropTypes.array.isRequired,
  summaryContent: PropTypes.array.isRequired,
  title: PropTypes.string,
  summaryPanel: PropTypes.array,
  currentSelectedImageIndex: PropTypes.number
};

GDTableSummaryHorizontalPanel.defaultProps = {
  extraClass: '',
  title: '',
  summaryFields: [],
  summaryContent: [],
  summaryPanel: [],
  isMerchantPortal: true,
};

export default GDTableSummaryHorizontalPanel;
